import type { Guest } from '../../types';

const GuestTextField = ({
    name,
    label,
    value,
    index,
    placeholder,
    onChange,
}: {
    name: keyof Guest;
    label: string;
    index: number;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}) => {
    return (
        <div className="row mb-3 form-group">
            <div className="col-md-4 col-form-label">
                <label htmlFor={`guest-${index}-${name}`}>{label}</label>
            </div>
            <div className="col-md-8">
                <input
                    type="text"
                    className="form-control"
                    id={`guest-${index}-${name}`}
                    placeholder={placeholder}
                    value={value}
                    onChange={(event) => {
                        onChange(event.target.value);
                    }}
                />
            </div>
        </div>
    );
};

export default GuestTextField;
